<div [class.menu-link-active]="isActive()" [class.menu-link-disabled]="!isEnabled()" class="tile" (click)="onClick()" title="{{item.description}}">
    <img [class.specialHeight]="item.isSpecialHeight" [src]="item.icon" />
    <span>{{item.name}}</span>
    <span class="link-hover" [restaurantColor]="{'type': restaurantType, 'background': true}"></span>
</div>